import React from 'react';
import CustomButton from "./CustomButton";
import NavigationButton from "./NavigationButton";
import {makeStyles} from '@material-ui/core/styles';
import {Toolbar, Typography} from '@material-ui/core';
import {Link} from 'react-router-dom';
import {useState} from 'react';

const styles = makeStyles({
    bar: {
        paddingTop: "0.42rem",
        alignItems: "center"
    },
    menuItem: {
        cursor:"pointer",
        color:"white",
        font: "Italiana",
        fontWeight: 900,
        flexGrow: 1,
        "&:hover": {
            color: "rgba(176,244,254,1)"
        },
    },
})

function getRandomInt(max) {
    return Math.floor(Math.random() * max) + 1;
}

function NavigationBar(){
    const classes = styles();
    const [randomInt, setRandomInt] = useState(getRandomInt(9999));
    const handleMintClick = (id) => {
        setRandomInt(getRandomInt(9999));
    }

    return (

            <Toolbar position="sticky" color="white" className={classes.bar}>            
                
                <Typography variant="h6" className={classes.menuItem}>
                    <Link to='/' style={{ textDecoration: 'none' }}>
                        <NavigationButton txt="Home"></NavigationButton>
                    </Link>
                </Typography>

                <Typography variant="h6" className={classes.menuItem}>
                    <Link to='/explore' style={{ textDecoration: 'none' }}>
                        <NavigationButton txt="Explore"></NavigationButton>
                    </Link>
                </Typography>

                <Typography variant="h6" className={classes.menuItem}>
                <Link to='/about' style={{ textDecoration: 'none' }}>
                    <NavigationButton txt="About"></NavigationButton>
                </Link>
                </Typography>   

                <Typography variant="h6" className={classes.menuItem}>
                <Link to='/rarities' style={{ textDecoration: 'none' }}>
                    <NavigationButton txt="Rarities"></NavigationButton>
                </Link>
                </Typography>        
                <Typography variant="h6" className={classes.menuItem}>
                    <CustomButton txt="Find Random Baron" id={randomInt} handleMintClick={handleMintClick}></CustomButton>
                </Typography>        
            </Toolbar>
    )
}

export default NavigationBar